import React from 'react';
import { Link } from 'react-router-dom';

export default function Footer() {
    return (
        <>
            <footer className="cm-footer">
                <div className="cm-footer-inner">
                    {/* Middle Row: columns */}
                    <div className="cm-footer-links-row">
                        <div className="cm-footer-col">
                            <h4 className="cm-footer-heading">Profit Technologies</h4>
                            {/* <img src={require('../assets/images')} alt='Profit Technologies' className='cm-footer-logo' /> */}
                            <ul>
                                <li>Gurgaon, Haryana, India</li>
                                <li>Mon - Fri: 9:00 AM - 6:00 PM</li>
                                <div className="cm-footer-social">
                                    <a href="https://www.facebook.com/" target="_blank" rel="noopener noreferrer"><button className="cm-footer-social-btn"><i class="fa fa-facebook" style={{ fontSize: '20px' }}></i></button></a>
                                    <a href="https://www.instagram.com/" target="_blank" rel="noopener noreferrer"><button className="cm-footer-social-btn"><i class="fa fa-instagram" style={{ fontSize: '20px' }}></i></button></a>
                                    <a href="https://www.linkedin.com/company/profit-technologies-inc/" target="_blank" rel="noopener noreferrer"><button className="cm-footer-social-btn"><i class="fa fa-linkedin" style={{ fontSize: '20px' }}></i></button></a>
                                    <a href="https://twitter.com/" target="_blank" rel="noopener noreferrer"><button className="cm-footer-social-btn"><i class="fa fa-twitter" style={{ fontSize: '20px' }}></i></button></a>
                                </div>

                            </ul>
                        </div>

                        <div className="cm-footer-col">
                            <h4 className="cm-footer-heading">Services</h4>
                            <ul>
                                <Link to="/services/website-development" style={{ textDecoration: 'none', color: 'inherit' }}>
                                    <li>Website Development</li>
                                </Link>
                                <Link to="/services/app-development" style={{ textDecoration: 'none', color: 'inherit' }}>
                                    <li>App Development</li>
                                </Link>
                                <Link to="/services/software-development" style={{ textDecoration: 'none', color: 'inherit' }}>
                                    <li>Software Development</li>
                                </Link>
                                <Link to="/services/startup-consulting" style={{ textDecoration: 'none', color: 'inherit' }}>
                                    <li>Startup Consulting</li>
                                </Link>
                                <Link to="/services/digital-marketing" style={{ textDecoration: 'none', color: 'inherit' }}>
                                    <li>Digital Marketing</li>
                                </Link>
                                <Link to="/services/it-consulting" style={{ textDecoration: 'none', color: 'inherit' }}>
                                    <li>IT Consulting</li>
                                </Link>
                            </ul>
                        </div>

                        <div className="cm-footer-col">
                            <h4 className="cm-footer-heading">Useful Links</h4>
                            <ul>
                                <Link to="/" style={{ textDecoration: 'none', color: 'inherit' }}>
                                    <li>Home</li>
                                </Link>
                                <Link to="/about" style={{ textDecoration: 'none', color: 'inherit' }}>
                                    <li>About Us</li>
                                </Link>
                                <Link to="/services" style={{ textDecoration: 'none', color: 'inherit' }}>
                                    <li>Services</li>
                                </Link>
                                {/* <Link to="/portfolio" style={{ textDecoration: 'none', color: 'inherit' }}>
                                    <li>Portfolio</li>
                                </Link> */}

                                <Link to="/clients" style={{ textDecoration: 'none', color: 'inherit' }}>
                                    <li>Clients</li>
                                </Link>
                                <Link to="/contact" style={{ textDecoration: 'none', color: 'inherit' }}>
                                    <li>Contact Us</li>
                                </Link>
                            </ul>
                        </div>

                        <div className="cm-footer-col">
                            <h4 className="cm-footer-heading">Resources</h4>
                            <ul>
                                <Link to="/case-study" style={{ textDecoration: 'none', color: 'inherit' }}>
                                    <li>Case Study</li>
                                </Link>
                                <Link to="/privacy-policy" style={{ textDecoration: 'none', color: 'inherit' }}>
                                    <li>Privacy Policy</li>
                                </Link>
                                <Link to="/terms" style={{ textDecoration: 'none', color: 'inherit' }}>
                                    <li>Terms</li>
                                </Link>
                                <Link to="/blogs" style={{ textDecoration: 'none', color: 'inherit' }}>
                                    <li>Blogs</li>
                                </Link>
                            </ul>
                        </div>
                    </div>

                    <hr className="cm-footer-divider" />

                    {/* Bottom Row: copyright */}
                    <div className="cm-footer-bottom">
                        Copyright © 2025 Profit Technologies. All rights reserved.
                    </div>
                </div>
            </footer>
        </>
    )
}
